import { setDerivedKey, setKeyPair, setPrivateKeyHash } from '@/store/slices/poc/pocAuthSlice';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const updateMlKemKeys = createAppAsyncThunk(
  'auth/updateMlKemKeys',
  async(
    { password }: { password: string },
    { getState, dispatch, extra: { authService, pocServices: { cryptoService } } }
  ) => {
    const state = getState();
    const email = state.auth.username;
    const userId = state.auth.userId;
    const token: string | undefined = state.auth.registrationToken ?? state.auth.recoveryToken;

    if (userId == null) {
      throw new Error('Cannot update ML-KEM keys: userId not set in state');
    }

    const hashResult = await cryptoService.hashPassword(password, email);

    const keyPair = await cryptoService.generateMlKemKeyPairFromCredentials(email, password);

    const encryptedPrivateKey = await cryptoService.encryptPrivateKey(keyPair.privateKey, hashResult);

    dispatch(setDerivedKey(hashResult.keyHex));
    dispatch(setKeyPair(keyPair));
    dispatch(setPrivateKeyHash(encryptedPrivateKey));

    const publicKeyArray = Array.from(keyPair.publicKey);
    await authService.updateMlkemKeys(userId, {
      encapsKey: JSON.stringify(publicKeyArray),
      decapsKey: encryptedPrivateKey
    }, token);
  }
);
